export default __webpack_public_path__ + "static/media/aerial-platform-basket.71bc46b1.webp";